import { UserLocalStorageKey } from "src/types"

export function getLocalStorageBaseURL(): string | null {
  return localStorage.getItem(UserLocalStorageKey.BaseURL)
}

export function setLocalStorageBaseURL(baseURL: string): void {
  localStorage.setItem(
    UserLocalStorageKey.BaseURL,
    baseURL,
  )
}

export function removeLocalStorageBaseURL(): void {
  localStorage.removeItem(UserLocalStorageKey.BaseURL)
}
